import { z } from "zod";
const translationPath =
  "page.4uMarCom.automationRules.marcom_categories.errors.";

const listCategorySchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "list_category" }
);

export const categoriesSchema = z.object({
  id: z.string().optional(),
  listCategory: listCategorySchema,
});

export type TCategoriesForm = z.infer<typeof categoriesSchema>;
